import React from 'react';
import { Upload, FileSpreadsheet } from 'lucide-react';

/**
 * Componente para upload de arquivos Excel
 */
const FileUpload = ({ onFileUpload, uploadError, loading, hasData = false }) => {
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      onFileUpload(file);
      event.target.value = '';
    }
  };

  if (hasData) {
    // Botão compacto quando já há dados
    return (
      <div className="relative">
        <input
          type="file"
          accept=".xlsx,.xls"
          onChange={handleFileChange}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
          id="new-file-upload"
          disabled={loading}
        />
        <label
          htmlFor="new-file-upload"
          className="inline-flex items-center px-4 py-2 border border-orange-300 text-sm font-medium rounded-md text-orange-100 hover:text-white hover:border-white cursor-pointer transition-colors"
        >
          <Upload className="h-4 w-4 mr-2" />
          Nova planilha
        </label>
      </div>
    );
  }

  // Área de upload principal quando não há dados
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="bg-white rounded-lg shadow-sm border-2 border-dashed border-gray-300 p-12 text-center">
        <FileSpreadsheet className="h-16 w-16 text-gray-400 mx-auto mb-4" />
        <h3 className="text-xl font-semibold text-gray-800 mb-2">
          Faça upload da sua planilha
        </h3>
        <p className="text-gray-600 mb-6">
          Selecione o arquivo Excel (.xlsx ou .xls) com os dados de atendimento do SeleneBOT
        </p>
        
        <div className="relative">
          <input
            type="file"
            accept=".xlsx,.xls"
            onChange={handleFileChange}
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            id="file-upload"
            disabled={loading}
          />
          <label
            htmlFor="file-upload"
            className={`inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white cursor-pointer transition-colors ${
              loading 
                ? 'bg-gray-400 cursor-not-allowed' 
                : 'bg-orange-600 hover:bg-orange-700'
            }`}
          >
            <Upload className="h-5 w-5 mr-2" />
            {loading ? 'Processando...' : 'Selecionar arquivo'}
          </label>
        </div>
        
        {uploadError && (
          <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-md">
            <p className="text-sm text-red-600">{uploadError}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FileUpload;
